<svelte:options accessors/>
<script lang="ts">
    import NauiSelect from "../../naui/atoms/NauiSelect.svelte";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import NauiInput from "../../naui/atoms/NauiInput.svelte";
    import {httpRequest, downloadPdf} from "../../utils";
    import Dialog, {Title, Content, Actions} from '@smui/dialog';


    export let sucursalProducto = {
        sucursal: [],
        producto: []
    }

    export let urlCertificado: string;
    export let ramo = []
    let ramo_selected = ''

    var parametros_body = {
        CompanyType: "",
        sucursal: "",
        ramo: "",
        poliza: "",
        endoso: ""
    };

    let dialogMessage = ''
    let open = false

    async function get_pdf_certi() {
        parametros_body.CompanyType = ramo_selected
        // console.log("get_pdf_certi")
        // console.log(parametros_body)
        downloadPdf({
            method: 'post',
            data: parametros_body,
            url: urlCertificado
        })
            .then(res => {
                console.log('res de downloadPdf', res)


                dialogMessage = res.statusMessage;
                open = true;

            })

    }


    function get_sucursal_producto() {

        httpRequest({
            method: 'post',
            data: {'ramo': ramo_selected}
        })
            .then(res => res.json())
            .then(data => {
                console.log(data)
                sucursalProducto.sucursal = data.sucursal
                sucursalProducto.producto = data.producto
            });

    }

</script>
<section class="max-w-300px mx-auto">
    <div class="mb-1">
        <NauiSelect label="Ramo" options={ramo} bind:value={ramo_selected}
                    on:change={get_sucursal_producto}/>
    </div>
    <div class="mb-1">
        <NauiSelect label="Sucursal" options={sucursalProducto.sucursal} bind:value={parametros_body.sucursal}/>
    </div>
    <div class="mb-1">
        <NauiSelect label="Producto" options={sucursalProducto.producto} bind:value={parametros_body.ramo}/>
    </div>
    <div class="mb-1">
        <NauiInput label="No. Póliza" bind:value={parametros_body.poliza}/>
    </div>
    <div class="mb-1">
        <NauiInput label="Endoso" bind:value={parametros_body.endoso}/>
    </div>
    <div class="mt-15">
        <NauiButton caption="Descargar" color="accent" mode="solid" className="min-w-300px" on:click={get_pdf_certi}/>
    </div>

    <Dialog bind:open>
        <Content>{ dialogMessage }</Content>
        <Actions>
            <NauiButton caption="Aceptar" color="accent" mode="solid" on:click={() => {open = false;}}/>
        </Actions>
    </Dialog>

</section>